import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const SHARE_DEFAULTS = {
    url: "",
    text: "Check this out",
    platforms: ["twitter", "facebook", "linkedin", "whatsapp", "email"],
    style: "outline",
    size: "md",
    showLabels: false,
    align: "start",
    color: "#111827",
};
const LABELS = {
    twitter: "Twitter",
    facebook: "Facebook",
    linkedin: "LinkedIn",
    whatsapp: "WhatsApp",
    telegram: "Telegram",
    reddit: "Reddit",
    email: "Email",
};
const ICONS = {
    twitter: "𝕏",
    facebook: "f",
    linkedin: "in",
    whatsapp: "✆",
    telegram: "✈",
    reddit: "↗",
    email: "✉",
};
function shareUrl(platform, url, text) {
    const u = encodeURIComponent(url || "");
    const t = encodeURIComponent(text || "");
    switch (platform) {
        case "twitter":
            return `https://twitter.com/intent/tweet?url=${u}&text=${t}`;
        case "facebook":
            return `https://www.facebook.com/sharer/sharer.php?u=${u}`;
        case "linkedin":
            return `https://www.linkedin.com/sharing/share-offsite/?url=${u}`;
        case "whatsapp":
            return `https://api.whatsapp.com/send?text=${t}%20${u}`;
        case "telegram":
            return `https://t.me/share/url?url=${u}&text=${t}`;
        case "reddit":
            return `https://www.reddit.com/submit?url=${u}&title=${t}`;
        case "email":
            return `mailto:?subject=${t}&body=${u}`;
    }
}
const ALIGN_MAP = { start: "flex-start", center: "center", end: "flex-end" };
const SIZE_PX = {
    sm: { h: 30, font: 12, paddingX: 10, iconBox: 22, gap: 6 },
    md: { h: 36, font: 13, paddingX: 12, iconBox: 28, gap: 8 },
    lg: { h: 44, font: 15, paddingX: 16, iconBox: 36, gap: 10 },
};
export const shareWidget = {
    type: "share",
    defaultProps: SHARE_DEFAULTS,
    renderHtml(props) {
        const platforms = (props.platforms ?? []).filter(Boolean);
        if (platforms.length === 0) {
            return `<div class="emk-share" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(No platforms selected)</div>`;
        }
        const style = props.style ?? "outline";
        const size = SIZE_PX[props.size ?? "md"];
        const align = props.align ?? "start";
        const showLabels = props.showLabels ?? false;
        const color = props.color ?? "#111827";
        const buttonStyle = (() => {
            const base = [
                "display:inline-flex",
                "align-items:center",
                "justify-content:center",
                `gap:${size.gap}px`,
                "text-decoration:none",
                "font-family:inherit",
                `font-size:${size.font}px`,
                "font-weight:500",
                "border-radius:8px",
                "transition:opacity 0.15s",
            ];
            if (showLabels) {
                base.push(`height:${size.h}px`, `padding:0 ${size.paddingX}px`);
            }
            else {
                base.push(`width:${size.iconBox}px`, `height:${size.iconBox}px`);
            }
            if (style === "solid") {
                base.push(`background:${color}`, "color:#fff", `border:1px solid ${color}`);
            }
            else if (style === "outline") {
                base.push("background:transparent", `color:${color}`, `border:1px solid ${color}`);
            }
            else {
                base.push("background:transparent", `color:${color}`);
            }
            return base.join(";");
        })();
        const tiles = platforms
            .map((p) => {
            const iconSpan = `<span aria-hidden="true" style="font-weight:600">${escapeHtml(ICONS[p])}</span>`;
            const labelSpan = showLabels ? escapeHtml(LABELS[p]) : "";
            return `<a href="${escapeAttr(shareUrl(p, props.url, props.text))}" target="_blank" rel="noopener noreferrer" aria-label="Share on ${escapeAttr(LABELS[p])}" style="${buttonStyle}">${iconSpan}${labelSpan}</a>`;
        })
            .join("");
        return `<div class="emk-share" style="display:flex;flex-wrap:wrap;gap:${size.gap}px;justify-content:${ALIGN_MAP[align]};font-family:inherit">${tiles}</div>`;
    },
};
//# sourceMappingURL=share.js.map